import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

interface ModalProps {
  show: boolean;
  handleClose: () => void;
  handleSubmit?: () => void;
  cancelButtonText?: string;
  continueButtonText?: string;
  text?: string;
  classNameText?: string;
}

const DefaultModal = ({
  handleClose,
  handleSubmit,
  show,
  classNameText,
  cancelButtonText = 'Cancel',
  continueButtonText = 'Continue',
  text = '',
}: ModalProps) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      keyboard={true}
      backdropClassName="stacked-backdrop"
    >
      <Modal.Body className={`${classNameText} pt-4`}>{text}</Modal.Body>
      <Modal.Footer className="d-flex justify-content-start">
        <Button
          size="sm"
          className="px-3 rounded-pill fw-bold btn-purple-outline"
          onClick={handleClose}
        >
          {cancelButtonText}
        </Button>
        {handleSubmit && (
          <Button
            variant="danger"
            size="sm"
            className="px-3 rounded-pill fw-bold"
            onClick={handleSubmit}
          >
            {continueButtonText}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default DefaultModal;
